var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 303,
    height: 63.12,
    viewBox: "0 0 303 63.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopoth_Logo",
    "data-name": "Shopoth Logo",
    transform: "translate(0 0.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 -0.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M408.484,431.421v35.118a2.884,2.884,0,0,1-2.884,2.883h-7.128a2.883,2.883,0,0,1-2.882-2.883V433.2a4.664,4.664,0,0,1,4.665-4.665H405.6A2.884,2.884,0,0,1,408.484,431.421Z",
    transform: "translate(-395.59 -428.537)",
    fill: "#ef4056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M463.725,428.537H456.6a2.883,2.883,0,0,0-2.882,2.884v35.118a2.883,2.883,0,0,0,2.882,2.883h7.128a2.884,2.884,0,0,0,2.884-2.883V431.421A2.884,2.884,0,0,0,463.725,428.537Z",
    transform: "translate(-437.257 -428.537)",
    fill: "#ef4056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M521.85,428.8h-7.128a2.882,2.882,0,0,0-2.882,2.884v12.894a2.882,2.882,0,0,0,2.882,2.882h7.128a2.883,2.883,0,0,0,2.883-2.882V431.684A2.883,2.883,0,0,0,521.85,428.8Z",
    transform: "translate(-478.925 -428.726)",
    fill: "#ef4056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M578.189,428.8h-5.345a2.884,2.884,0,0,0-2.884,2.884v12.894a2.883,2.883,0,0,0,2.884,2.882h7.128a2.882,2.882,0,0,0,2.882-2.882V433.465A4.665,4.665,0,0,0,578.189,428.8Z",
    transform: "translate(-520.588 -428.726)",
    fill: "#ef4056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M457.856,509.91v33.338a4.665,4.665,0,0,1-4.665,4.665H400.255a4.664,4.664,0,0,1-4.665-4.665V532.134a2.882,2.882,0,0,1,2.882-2.882h45.389a1.1,1.1,0,0,0,1.1-1.1v-1.369a1.1,1.1,0,0,0-.978-1.094c-.04,0-.081-.007-.123-.007s-.083,0-.123.007h-12.35A2.884,2.884,0,0,1,428.5,522.8V509.91a2.884,2.884,0,0,1,2.884-2.883h23.586A2.883,2.883,0,0,1,457.856,509.91Z",
    transform: "translate(-395.59 -484.803)",
    fill: "#21409a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(74.168 22.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M688.188,535.83a11.24,11.24,0,0,1-2.074,6.784,12.849,12.849,0,0,1-5.6,4.326,20.057,20.057,0,0,1-7.786,1.47,28.4,28.4,0,0,1-8.652-1.181,15.85,15.85,0,0,1-6.536-4.092l6.317-6.317a8.682,8.682,0,0,0,3.9,2.156,18.646,18.646,0,0,0,5.026.673q5.741,0,5.741-3.6a3.264,3.264,0,0,0-.8-2.362,4.416,4.416,0,0,0-2.637-1.071l-4.834-.687q-5.329-.741-8.048-3.543-2.747-2.828-2.747-8.047a12.175,12.175,0,0,1,1.771-6.523,12.005,12.005,0,0,1,5.082-4.49,17.454,17.454,0,0,1,7.759-1.62,23.743,23.743,0,0,1,7.731,1.14,14.823,14.823,0,0,1,5.782,3.639l-6.18,6.18a6.894,6.894,0,0,0-3.324-1.95,19.3,19.3,0,0,0-4.284-.412,5.17,5.17,0,0,0-3.6,1.126,3.412,3.412,0,0,0-1.236,2.582,2.56,2.56,0,0,0,.8,1.868,4.655,4.655,0,0,0,2.747,1.181l4.834.659q5.273.77,7.883,3.324a8.788,8.788,0,0,1,2.266,3.666A16.671,16.671,0,0,1,688.188,535.83Z",
    transform: "translate(-657.536 -507.705)",
    fill: "#21409a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M808.876,548.914h-9.833V533.039H788.579v15.875h-9.833V508.869h9.833v15.408h10.465V508.869h9.833Z",
    transform: "translate(-744.426 -508.539)",
    fill: "#21409a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M929.84,528.057V529.4q0,3.351-.234,5.768a17.4,17.4,0,0,1-1.111,4.669,11.749,11.749,0,0,1-2.69,4.065,15.478,15.478,0,0,1-4.9,3.364,15.978,15.978,0,0,1-6.3,1.14,17.6,17.6,0,0,1-4.406-.509,13.79,13.79,0,0,1-3.622-1.5,15.61,15.61,0,0,1-3.142-2.5,11.872,11.872,0,0,1-3.348-5.988,42.057,42.057,0,0,1-.712-8.514v-2.692a42.276,42.276,0,0,1,.712-8.528,11.874,11.874,0,0,1,3.348-6,15.215,15.215,0,0,1,4.927-3.378,18.3,18.3,0,0,1,12.526.014,15.256,15.256,0,0,1,4.911,3.365,11.719,11.719,0,0,1,2.69,4.079,17.588,17.588,0,0,1,1.111,4.683q.233,2.417.234,5.768Zm-9.833,0a46.214,46.214,0,0,0-.343-6.976,6.594,6.594,0,0,0-1.112-2.856,4,4,0,0,0-1.607-1.263,5.474,5.474,0,0,0-2.348-.494,5.262,5.262,0,0,0-2.279.481,4.54,4.54,0,0,0-1.649,1.277,5.286,5.286,0,0,0-.81,1.552,12.738,12.738,0,0,0-.481,2.829q-.164,1.909-.165,5.452,0,3.516.165,5.424a12.484,12.484,0,0,0,.481,2.815,5.322,5.322,0,0,0,.81,1.538,5.192,5.192,0,0,0,7.884,0,7.228,7.228,0,0,0,1.112-2.87A44.706,44.706,0,0,0,920.007,528.057Z",
    transform: "translate(-830.904 -507.705)",
    fill: "#21409a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M1050.7,521.75a12.957,12.957,0,0,1-1.607,6.317,12.337,12.337,0,0,1-4.682,4.751,14.307,14.307,0,0,1-7.388,1.813h-6.015v14.282h-9.833V508.869h15.861a14.364,14.364,0,0,1,7.381,1.8,12.236,12.236,0,0,1,4.678,4.738A13.023,13.023,0,0,1,1050.7,521.75Zm-9.833.014a4.094,4.094,0,0,0-.51-2,3.822,3.822,0,0,0-1.487-1.492,4.481,4.481,0,0,0-2.272-.562h-5.592v8.075h5.592a4.481,4.481,0,0,0,2.272-.561,3.852,3.852,0,0,0,1.487-1.478A4.017,4.017,0,0,0,1040.867,521.764Z",
    transform: "translate(-918.212 -508.539)",
    fill: "#21409a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1161.7,528.057V529.4q0,3.351-.234,5.768a17.346,17.346,0,0,1-1.111,4.669,11.76,11.76,0,0,1-2.689,4.065,15.484,15.484,0,0,1-4.9,3.364,15.982,15.982,0,0,1-6.3,1.14,17.582,17.582,0,0,1-4.4-.509,13.788,13.788,0,0,1-3.623-1.5,15.566,15.566,0,0,1-3.141-2.5,11.865,11.865,0,0,1-3.348-5.988,41.97,41.97,0,0,1-.713-8.514v-2.692a42.188,42.188,0,0,1,.713-8.528,11.867,11.867,0,0,1,3.348-6,15.214,15.214,0,0,1,4.925-3.378,18.3,18.3,0,0,1,12.527.014,15.256,15.256,0,0,1,4.912,3.365,11.73,11.73,0,0,1,2.689,4.079,17.531,17.531,0,0,1,1.111,4.683q.233,2.417.234,5.768Zm-9.833,0a46.091,46.091,0,0,0-.343-6.976,6.584,6.584,0,0,0-1.113-2.856,4,4,0,0,0-1.606-1.263,5.478,5.478,0,0,0-2.349-.494,5.271,5.271,0,0,0-2.279.481,4.54,4.54,0,0,0-1.648,1.277,5.277,5.277,0,0,0-.811,1.552,12.781,12.781,0,0,0-.48,2.829q-.166,1.909-.165,5.452,0,3.516.165,5.424a12.525,12.525,0,0,0,.48,2.815,5.314,5.314,0,0,0,.811,1.538,5.191,5.191,0,0,0,7.882,0,7.215,7.215,0,0,0,1.113-2.87A44.589,44.589,0,0,0,1151.862,528.057Z",
    transform: "translate(-997.111 -507.705)",
    fill: "#ef4056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1274.145,517.631h-9.86v31.283h-9.833V517.631h-9.859v-8.762h29.552Z",
    transform: "translate(-1078.371 -508.539)",
    fill: "#ef4056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1389.434,548.914H1379.6V533.039h-10.464v15.875H1359.3V508.869h9.833v15.408H1379.6V508.869h9.833Z",
    transform: "translate(-1160.603 -508.539)",
    fill: "#ef4056"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0dd267f4e45a387579aa120a0e5f706.svg";
export { ForwardRef as ReactComponent };